import {
  FETCH_CUSTOMER_CONTRACTS_REQUEST,
  FETCH_CUSTOMER_CONTRACTS_SUCCESS,
  FETCH_CUSTOMER_CONTRACTS_FAILURE,
} from '../../../actions/actionTypes'

import fetchStatusesByCustomerIdReducerCreator from '../higherOrderReducers/reducerCreators/byCustomerId'

export default fetchStatusesByCustomerIdReducerCreator(
  FETCH_CUSTOMER_CONTRACTS_REQUEST,
  FETCH_CUSTOMER_CONTRACTS_SUCCESS,
  FETCH_CUSTOMER_CONTRACTS_FAILURE,
)
